module.exports = __webpack_public_path__ + "fonts/Mulish.ttf?17e081942f31df1099bfe138efd48739";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Mulish.ttf
// module id = 319
// module chunks = 0